import React from "react";
import { dateFormator } from "../../../../../../utils";

// Render 7 days (Mon-Sun) at once, with a weekly total column
const TimesheetData = (items, index) => {
  // Only render a row when starting a week
  if (index % 7 !== 0) return null;

  const weekItems = items.slice(index, index + 7);

  const tags = [
    "Pay Classification",
    "Standard Time",
    "Total Billable Hours",
    "Total Hours",
  ];

  const parseTime = (timeStr) => {
    if (!timeStr) return { hours: 0, minutes: 0 };
    const [h, m] = timeStr.split(".");
    return { hours: Number(h) || 0, minutes: Number(m) || 0 };
  };

  const sumTimes = (arr, key) => {
    const total = arr.reduce(
      (acc, it) => {
        const { hours, minutes } = parseTime(it[key]);
        acc.hours += hours;
        acc.minutes += minutes;
        if (acc.minutes >= 60) {
          acc.hours += Math.floor(acc.minutes / 60);
          acc.minutes %= 60;
        }
        return acc;
      },
      { hours: 0, minutes: 0 }
    );
    const decimal = Number((total.hours + total.minutes / 60).toFixed(2));
    return decimal.toFixed(2);
  };

  const weekTotals = {
    standardTime: sumTimes(weekItems, "standardTime"),
    totalBillableHours: sumTimes(weekItems, "totalBillableHours"),
    totalHours: sumTimes(weekItems, "totalHours"),
  };

  const classificationFor = (it) => {
    if (it.standardTime == null && it.totalHours == null) return "--";
    const day = new Date(it.date).getDay();
    const hasHours = !!it.totalHours && it.totalHours !== "00.00";
    if (day === 0 || day === 6) return hasHours ? "Weekend" : "Off";
    return hasHours ? "Regular" : "Off";
  };

  const formatTime = (t) => (t == null || t === "" ? "--" : t);

  return (
    <div key={index} className="measure-row px-5">
      <div className="text-xs box-border grid grid-cols-[1.5fr_repeat(8,1fr)] gap-1 py-2 border-b border-neutral-100">
        {/* Left tag names */}
        <div className="text-center">
          {tags.map((tag, idx) => (
            <div key={idx} className="text-right px-2 py-1">
              {tag}
            </div>
          ))}
        </div>

        {/* Seven day columns (Mon-Sun) */}
        {weekItems.map((it, i) => (
          <div
            key={i}
            className={
              "flex flex-col items-center justify-center" +
              (it.standardTime == null &&
              it.totalBillableHours == null &&
              it.totalHours == null
                ? " opacity-50"
                : "")
            }
          >
            <div className="px-2 py-1 text-center">
              {/* here i need the date in the format of dd-mm-yyyy */}
              {dateFormator(it?.date, "month-date")}
            </div>
            <div className="px-2 py-1 text-center">
              {formatTime(it.standardTime)}
            </div>
            <div className="px-2 py-1 text-center">
              {formatTime(it.totalBillableHours)}
            </div>
            <div className="px-2 py-1 text-center">
              {formatTime(it.totalHours)}
            </div>
          </div>
        ))}

        {/* Weekly totals column */}
        <div className="flex flex-col items-center justify-center">
          <div className="px-2 py-1 text-center">&nbsp;</div>
          <div className="px-2 py-1 text-center">{weekTotals.standardTime}</div>
          <div className="px-2 py-1 text-center">
            {weekTotals.totalBillableHours}
          </div>
          <div className="px-2 py-1 text-center">{weekTotals.totalHours}</div>
        </div>
      </div>
    </div>
  );
};

export default TimesheetData;
